"use strict";

var _classCallCheck = require("C:\\Projects\\far-fruit\\node_modules\\@babel\\runtime\\helpers\\classCallCheck.js");

var _createClass = require("C:\\Projects\\far-fruit\\node_modules\\@babel\\runtime\\helpers\\createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrameManager = void 0;

var FrameManager = /*#__PURE__*/function () {
  function FrameManager(container) {
    _classCallCheck(this, FrameManager);

    this.container = container;
  }

  _createClass(FrameManager, [{
    key: "nextFrame",
    value: function nextFrame(timestamp) {
      var _a;

      try {
        var container = this.container;

        if (container.lastFrameTime !== undefined && timestamp < container.lastFrameTime + 1000 / container.fpsLimit) {
          container.draw(false);
          return;
        }

        (_a = container.lastFrameTime) !== null && _a !== void 0 ? _a : container.lastFrameTime = timestamp;
        var deltaValue = timestamp - container.lastFrameTime;
        var delta = {
          value: deltaValue,
          factor: 60 * deltaValue / 1000
        };
        container.lifeTime += delta.value;
        container.lastFrameTime = timestamp;

        if (deltaValue > 1000) {
          container.draw(false);
          return;
        }

        container.particles.draw(delta);

        if (container.duration > 0 && container.lifeTime > container.duration) {
          container.destroy();
          return;
        }

        if (container.getAnimationStatus()) {
          container.draw(false);
        }
      } catch (e) {
        console.error("tsParticles error in animation loop", e);
      }
    }
  }]);

  return FrameManager;
}();

exports.FrameManager = FrameManager;